module.exports = __webpack_public_path__ + "static/img/2.f07559de.png";